import ScrollArea from "./ScrollArea";

export default ScrollArea;
